import type { FC } from 'react';
import React, { Fragment } from 'react';

// eslint-disable-next-line import/no-cycle
import type { InlineRenameProps } from './index.ts';
import { InlineRename } from './index.ts';

export const ConditionalInlineRename: FC<InlineRenameProps> = ({
	children,
	isEditingTitle,
	...props
}) => {
	if (isEditingTitle) {
		return (
			<InlineRename {...props} isEditingTitle={isEditingTitle}>
				{children}
			</InlineRename>
		);
	}
	return <Fragment>{children}</Fragment>;
};
